import React from "react";
import "./Payment.css";

function Payments({ payment, cards }) {
  const handleDownload = async (orderid) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/invoice.php?order_id=${orderid}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download PDF");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `invoice_${orderid}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Clean upf
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const upcomingpayment = payment.filter(
    (pay) => pay.status?.toLowerCase() === "pending"
  ).length;

  const latestPaid = payment
    .filter((pay) => pay.status?.toLowerCase() === "paid")
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

  const formattedDate = latestPaid
    ? new Date(latestPaid.created_at).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
      })
    : null;
    
  return (
    <>
      <h1 className="dashboard-heading">Invoice & Payments</h1>
      <div className="payment-dashboard">
        {/* <h1>Payments Dashboard</h1> */}

        {/* Summary Cards */}
        <div className="summary-cards">
          <div className="cardpay">
            <h3>Total Earnings</h3>
            <p>{cards?.total_sales}</p>
          </div>
          <div className="cardpay">
            <h3>Upcoming Payment</h3>
            <p>{upcomingpayment > 0 ? upcomingpayment : "-"}</p>
          </div>
          <div className="cardpay">
            <h3>Last Paid</h3>
            {latestPaid ? (
              <p>
                ₹{latestPaid.total_amount}{" "}
                <span className="date-label">on {formattedDate}</span>
              </p>
            ) : (
              <p>No recent paid payments</p>
            )}
          </div>
        </div>

        {/* Payment History Table */}
        <section className="payment-table-section">
          <table className="payment-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Order ID</th>
                <th>Date</th>
                <th>Amount (₹)</th>
                <th>Payment Method</th>
                <th>Transaction id</th>
                <th>Status</th>
                <th>Invoice</th>
              </tr>
            </thead>
            <tbody>
              {payment.map((pay, index) => (
                <tr key={pay.orderid}>
                  <td>{index + 1}</td>
                  <td>{pay.orderid}</td>
                  <td>{pay.created_at}</td>
                  <td>{pay.total_amount}</td>
                  <td>{pay.payment_method}</td>
                  <td>{pay.transaction_id}</td>
                  <td>
                    {" "}
                    <span
                      className={`${
                        pay.payment_status.toLowerCase() === "paid"
                          ? "status paid"
                          : "status pending"
                      }`}
                    >
                      {pay.payment_status}
                    </span>
                  </td>
                  <td>
                    <button
                      className="download-btn"
                      onClick={() => {
                        handleDownload(pay.id);
                      }}
                      disabled={pay.payment_status.toLowerCase() !== "paid"}
                    >
                      {pay.payment_status.toLowerCase() === "paid"
                        ? "Download"
                        : "Not Available"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </>
  );
}

export default Payments;
